var parallaxImg = document.querySelectorAll('.parallax');
var parallaxBanner = document.querySelectorAll('.parallax--banner');


if (parallaxImg.length) {
    var parallax = new Rellax('.parallax', {
        speed: -4,
        center: true
    });

    window.addEventListener('load', parallaxDestroy(parallax));
}

if (parallaxBanner.length) {
    var parallaxBanner = new Rellax('.parallax--banner', {
        speed: -4
    });

    window.addEventListener('load', parallaxDestroy(parallaxBanner));
}

function parallaxDestroy(element) {
    let win = this;
    if (win.innerWidth < 900) {
        element.destroy();
    }
}